import React from 'react';
import PropTypes from 'prop-types';
// Helpers
import { calcTime, convertMoney, compactMoney, formatDate } from '../../helpers';
// Styles
import { Wrapper, Stat } from './MovieStats.styles';

const MovieStats = ({ movie }) => {
  const { budget, revenue, runtime, release_date } = movie;
  const multiple = budget > 0 && revenue > 0 ? revenue / budget : null;
  const profit = budget > 0 && revenue > 0 ? revenue - budget : null;

  const stats = [
    { label: 'Release date', value: formatDate(release_date) },
    { label: 'Running time', value: calcTime(runtime) },
    { label: 'Budget', value: compactMoney(budget), title: convertMoney(budget) },
    { label: 'Revenue', value: compactMoney(revenue), title: convertMoney(revenue) },
    {
      label: profit !== null && profit < 0 ? 'Loss' : 'Profit',
      value: profit !== null ? compactMoney(Math.abs(profit)) : '—',
      title: profit !== null ? convertMoney(profit) : undefined,
      note: multiple ? `${multiple.toFixed(1)}× budget` : null,
      tone: profit === null ? null : profit >= 0 ? 'up' : 'down'
    }
  ];

  return (
    <Wrapper aria-label='Key facts'>
      {stats.map(stat => (
        <Stat key={stat.label} $tone={stat.tone}>
          <span>{stat.label}</span>
          <strong title={stat.title}>{stat.value}</strong>
          {stat.note && <small>{stat.note}</small>}
        </Stat>
      ))}
    </Wrapper>
  );
};

MovieStats.propTypes = {
  movie: PropTypes.object.isRequired
};

export default MovieStats;
